module.exports = __webpack_public_path__ + "static/media/sync_alt_white_24dp.06afec16.svg";